<template>
  <div class="app">
    <el-menu
        :default-active="activeName"
        class="el-menu-vertical-demo"
        router
        @open="handleOpen"
        @close="handleClose"
        >
      <el-menu-item index="/">欢迎</el-menu-item>
      <div v-for="(menu,index) in menuData" :key="index">
      <div class="menu-line"></div>
      <el-submenu :index="menu.path">
        <template slot="title">
          <span>{{menu.meta.title}}</span>
        </template>
        <div v-for="(child,i) in menu.children" :key="i">
          <el-menu-item :index="child.path" v-if="!child.hidden">{{child.meta.title}}</el-menu-item>
        </div>
      </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import http from '@/utils/http'
import api from '@/api'
  export default {
    data() {
      return {
        menuData:[]
      }
    },
    computed: {
      activeName () {
        const route = this.$route
        const { meta, path } = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
    },
    created () {
      this.makeMenu()
    },
    methods: {
      routeTree (list, accessArr) {
        const newlist = [...list]
        for (let i = 0; i < newlist.length; i++) {
          const res = Object.assign({}, newlist[i])
          if (res.meta.access !== undefined && !accessArr.includes(res.meta.access)) {
            newlist.splice(i, 1)
            i--
          } else {
            if (res.children && res.children.length > 0) {
              res.children = this.routeTree(res.children, accessArr)
              newlist[i] = res
            }
          }
        }
        return newlist
      },
      makeMenu(){
        let menuList = this.$router.options.routes[1].children
        if(this.$store.state.userinfo.access!='all'){
          const accessArr = this.$store.state.userinfo.access.harfCheckedKeys.concat(this.$store.state.userinfo.access.checkedKeys)
          if (accessArr !== undefined) {
            menuList = this.routeTree(menuList, accessArr)
          }
        }
        this.menuData = menuList
      },
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      }
    }
  }
</script>
<style scoped>
.el-menu{
  height: calc(100vh - 30px);
  border-right:1px solid #e9e9e9;
  text-align: left;
  padding-top:10px;
}
</style>